import { createFileRoute, redirect } from '@tanstack/react-router';
import { PasswordResetPage } from '@/pages/auth/ui/PasswordResetPage';
import { tokenManager } from '@/shared/lib/storage';

/**
 * パスワード再発行のお問い合わせルート定義
 *
 * App層の責務:
 * - URLパス `/password-reset` を PasswordResetPage にマッピング
 * - すでに認証済みの場合は `/projects` にリダイレクト
 */
export const Route = createFileRoute('/password-reset')({
  beforeLoad: () => {
    // すでに認証済みの場合は /projects にリダイレクト
    if (tokenManager.isAuthenticated()) {
      throw redirect({
        to: '/projects',
      });
    }
  },
  component: PasswordResetPage,
});
